import 'react-loading-skeleton/dist/skeleton.css';

import { useContext, useEffect, useState } from 'react';
import Skeleton from 'react-loading-skeleton';

import { endpoints } from '@/API/endpoints';
import LoggingTable from '@/components/tables/LoggingTable/LoggingTable';
import TableDesktop from '@/components/tables/LoggingTable/TableDesktop/TableDesktop';
import CrossFill from '@/components/ui/icons/CrossFill';
import PlusFill from '@/components/ui/icons/PlusFill';
import { UserInfoContext } from '@/context/UserInfoContext';
import { useApi } from '@/hooks/useApi/useApi';

import classes from './Logging.module.scss';

const Logging = () => {
	const [isFormOpen, setIsFormOpen] = useState(false);
	const [updateTable, setUpdateTable] = useState<boolean>(false);
	const { apiGet } = useApi();
	const { userInfoContext, setUserDetailInfoContext } =
		useContext(UserInfoContext);

	let classNameAddTask, iconComponent;

	if (isFormOpen) {
		classNameAddTask = classes['addTask--open'];
		iconComponent = <CrossFill clazz={classes.cross} />;
	} else {
		classNameAddTask = classes.addTask;
		iconComponent = <PlusFill clazz={classes.plus} />;
	}

	const userId = userInfoContext?.data.id;

	const skeletonTable = {
		count: 10,
		style: {
			height: '40px',
			marginBottom: '16px',
			display: 'block',
			width: '100%',
		},
		containerClassName: classes.skeletonTable,
	};

	useEffect(() => {
		const getFullUserInfo = async () => {
			const res = await apiGet(endpoints.fullCurrentUserInfo);
			if (res && setUserDetailInfoContext) setUserDetailInfoContext(res);
		};
		if (updateTable) getFullUserInfo();
	}, [updateTable]);

	return (
		<div className={classes.container}>
			{userId ? (
				<LoggingTable
					apiUrl={`${endpoints.userLoggingList}${userId}`}
					updateTable={updateTable}
					setUpdateTable={setUpdateTable}
					pagination={true}
					editable={!isFormOpen}
					skeleton={skeletonTable}
					onlyOnceSkeleton={true}
				>
					{
						<div className={classes.formContainer}>
							<div className={classNameAddTask}>
								<div onClick={() => setIsFormOpen(!isFormOpen)}>
									{iconComponent}
								</div>
							</div>
						</div>
					}
					{isFormOpen && (
						<TableDesktop
							setUpdateTable={setUpdateTable}
							setIsFormOpen={setIsFormOpen}
						/>
					)}
				</LoggingTable>
			) : (
				<Skeleton
					containerClassName={skeletonTable.containerClassName}
					count={skeletonTable.count}
					style={skeletonTable.style}
				/>
			)}
		</div>
	);
};

export default Logging;
